// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__CK1hs","col":"styles_col__N2G-v"};